module.exports = __webpack_public_path__ + "img/Solar-Space_symbol_0.882f33fe.png";